import { Box, Typography } from "@mui/material";

import Iconify from "components/iconify";
import "./style.css";

//----------------------------------------------------------------
const Feature = ({ header, body, label, icon }) => {
  return (
    <Box
      className="feature-card"
    >
      <Box className="feature-card__icon">
        <Iconify icon={icon} color="#f15e22" width={35} />
      </Box>

      {label && <span className="feature-card__label">{label}</span>}
      <Typography className="feature-card__title" variant="h6">
        {header}
      </Typography>
      <Typography className="feature-card__body" variant="body1">
        {body}
      </Typography>
    </Box>
  );
};

export default Feature;
